import ActivityBanner from '@/components/activityComponents/activityBanner';
import ActivityHeader from '@/components/activityComponents/activityHeader';
import Content from '@/components/activityComponents/lvs/Content';
import Description from '@/components/activityComponents/lvs/Description';
import Moment from '@/components/activityComponents/lvs/Moment';
import { useUserAgentInfo } from '@/context/user-agent';
import styles from '@/styles/common.module.scss';
import {
  HEADER_MENUS,
  BANNER_DATA,
  DESCRIPTION,
  AGENDA_CONTENT,
  MOMENT,
} from '@/utils/const/activity/lvs';

const LVS = () => {
  const { isMobile } = useUserAgentInfo();
  return (
    <>
      {!isMobile && <ActivityHeader nav={HEADER_MENUS} theme="light" />}
      <ActivityBanner data={BANNER_DATA} />
      <div
        className={styles['wrapper']}
        style={{
          background:
            'linear-gradient(180deg, #C4E8FF 4.7%, #D7E7FF 26.72%, #C8E6FE 100%)',
          paddingTop: 40,
        }}
      >
        <Description {...DESCRIPTION} />
        <Content {...AGENDA_CONTENT} />
        <Moment {...MOMENT} />
      </div>
    </>
  );
};

export default LVS;
